import "core-js/modules/es.function.name.js";
import React from 'react';
import { Hint } from '../../Hint';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var positions = ['default', 'left', 'right', 'bottom-static'];
export var InputHint = function InputHint(_ref) {
  var name = _ref.name,
    view = _ref.view,
    position = _ref.position,
    content = _ref.content,
    info = _ref.info,
    warning = _ref.warning,
    error = _ref.error;
  if (info) {
    content = info;
    view = 'info';
  }
  if (warning) {
    content = warning;
    view = 'warning';
  }
  if (error) {
    content = error;
    view = 'error';
  }
  if (!content) {
    return null;
  }
  return _jsx(Hint, {
    testId: "".concat(name, "-inputHint"),
    view: view,
    position: position,
    children: content
  });
};
//# sourceMappingURL=index.js.map